const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]"]);

export function messengerOriginsMatch(expectedOrigin, actualOrigin) {
  if (!expectedOrigin || expectedOrigin === "*") {
    return true;
  }

  if (!actualOrigin) {
    return false;
  }

  if (expectedOrigin === actualOrigin) {
    return true;
  }

  try {
    const expected = new URL(expectedOrigin);
    const actual = new URL(actualOrigin);

    if (expected.protocol !== actual.protocol || expected.port !== actual.port) {
      return false;
    }

    return (
      LOOPBACK_HOSTS.has(expected.hostname) &&
      LOOPBACK_HOSTS.has(actual.hostname)
    );
  } catch (_error) {
    return false;
  }
}
